import { makeAutoObservable } from 'mobx';
import type { ISecodaEntity } from '../../api';
import {
	fetchSecodaEntity,
	updateSecodaEntity,
} from '../../api/hooks/secodaEntity/fetchSecodaEntities';
import type { DjangoValueType } from '../../pages/TemplatePage/types';
import { updateTableRow } from '../CatalogView/events';

export class EntityDrawerStore {
	// @ts-expect-error TS(2564): Property 'entity' has no initializer and is not de... Remove this comment to see the full error message
	entity: ISecodaEntity;

	isOpen = false;

	loading = false;

	isError = false;

	isEditable = false;

	title = '';

	description = '';

	icon = '🗂';

	onClose?: () => void;

	constructor() {
		makeAutoObservable(this);
	}

	setLoading() {
		this.loading = true;
	}

	resetLoading() {
		this.loading = false;
	}

	setIsError = (value: boolean) => {
		this.isError = value;
	};

	openEntityDrawerById = async (
		isEditable: boolean,
		id: string,
		params: unknown = undefined,
		onClose: (() => void) | undefined = undefined
	) => {
		this.setLoading();
		this.setIsOpen(true);

		this.isEditable = isEditable;
		this.onClose = onClose;
		await fetchSecodaEntity(id, params)
			.then((entity) => {
				this.entity = entity;

				this.title = entity.title || 'Untitled';
				this.description = entity.description || '';
				if (entity.icon) {
					this.icon = entity.icon;
				}

				this.resetLoading();
			})
			.catch(() => {
				this.resetLoading();
				this.setIsError(true);
			});
	};

	openEntityDrawerWithError = () => {
		this.setIsError(true);
		this.setIsOpen(true);
	};

	updateEntity = async (
		key: string,
		value: DjangoValueType,
		saveRemotely = true
	) => {
		// @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
		this.entity[key] = value;
		if (saveRemotely) {
			await updateSecodaEntity({
				data: {
					id: this.entity.id,
					[key]: value,
				},
			});
		}
	};

	updateByKey =
		(key: string) =>
		async (value: DjangoValueType, saveRemotely = true) => {
			await this.updateEntity(key, value, saveRemotely);
		};

	setTitle = (value: string) => {
		this.title = value;
	};

	setDescription = (value: string) => {
		this.description = value;
	};

	setIcon = (value: string) => {
		this.icon = value;
	};

	setIsOpen = (value: boolean) => {
		this.isOpen = value;
	};

	closeEntityDrawer = () => {
		this.setIsOpen(false);
		this.setIsError(false);
		this.resetLoading();

		// table v1
		updateTableRow(this.entity);

		this.onClose?.();
		this.onClose = undefined;
	};
}

export default new EntityDrawerStore();
